module.exports = __webpack_public_path__ + "static/media/temp_zakhm.885a5be3.png";